<template>
  <Header></Header>
  <SideBar></SideBar>

  <Body pageTitle="Account Comment" class="chat-layout">
    <template v-slot:body>
      <div class="page-sale-account-comment-container">
        <div class="app-inner-layout chat-layout">
          <div class="app-inner-layout__wrapper">
            <div class="app-inner-layout__sidebar card">
              <div class="app-inner-layout__sidebar-header">
                <ul class="nav flex-column">
                  <li class="pt-4 pl-3 pr-3 pb-3 nav-item">
                    <div class="input-group">
                      <input placeholder="Search..." type="text" class="form-control" @keyup.enter="searchAccount()" @change="query.accounts.search = $event.target.value" />
                      <div class="input-group-append" @click="searchAccount()">
                        <div class="input-group-text">
                          <i class="ti ti-search"></i>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="nav-item-header nav-item">Accounts</li>
                </ul>
              </div>
              <div class="app-inner-layout__sidebar-body scrollbar" ref="accountSidebar">
                <div v-if="accounts.length == 0" class="h5 text-center text-secondary">No Account</div>
                <ul v-else class="nav flex-column">
                  <li :class="'nav-item item-' + _account.id" v-for="_account in accounts" :key="_account.id" @click="chooseAccount(_account.id)">
                    <button type="button" tabindex="0" :class="'dropdown-item' + [_account.id == query.accounts.selected ? ' active' : '']">
                      <div class="widget-content p-0">
                        <div class="widget-content-wrapper">
                          <div class="widget-content-left mr-3">
                            <div class="avatar-icon-wrapper position-relative">
                              <div v-if="_account.logged" class="badge badge-bottom badge-success badge-dot badge-dot-lg"></div>
                              <div class="avatar-icon">
                                <img :src="noThumbnail" />
                              </div>
                              <div v-if="_account.notification.comments" class="comment-count">
                                {{ _account.notification.comments }}
                              </div>
                            </div>
                          </div>
                          <div class="widget-content-left">
                            <div class="widget-heading">{{ _account.text }}</div>
                            <div class="widget-subheading">{{ _account.server }}</div>
                          </div>
                        </div>
                      </div>
                    </button>
                  </li>
                </ul>
              </div>
            </div>

            <div class="app-inner-layout__sidebar card">
              <div class="bg-white">
                <div class="app-inner-layout__sidebar-body scrollbar" ref="clientSidebar">
                  <div v-if="clients.length == 0" class="h5 text-center text-secondary">No customers</div>
                  <ul v-else class="nav flex-column">
                    <li v-for="client in clients" :key="client.id" :class="['item', client.readed == true ? 'item-readed' : 'item-unread']">
                      <button type="button" tabindex="0" :class="['dropdown-item', client.id == query.client.selected ? 'active' : '']">
                        <div class="widget-content p-0" @click="chooseClient(client.id)">
                          <div class="widget-content-wrapper">
                            <div class="widget-content-left mr-3">
                              <img width="42" class="rounded-circle" :src="client.thumbnail" />
                            </div>
                            <div class="widget-content-left">
                              <div class="widget-heading" v-html="client.title"></div>
                              <div class="widget-subheading">
                                <p class="client-excerpt mb-0" v-html="client.description"></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div :class="'app-inner-layout__content card' + [!query.accounts.selected || !query.client.selected ? ' has-overlay' : '']">
              <div class="table-responsive" ref="commentWrapper">
                <div class="app-inner-layout__top-pane">
                  <div class="pane-left">
                    <div class="mobile-app-menu-btn">
                      <button type="button" class="hamburger hamburger--elastic">
                        <span class="hamburger-box">
                          <span class="hamburger-inner"></span>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="chat-wrapper scrollbar" ref="messegerContent">
                  <div class="clearfix">
                    <div v-for="comment in comments" :key="comment.id">
                      <div class="chat-box-wrapper flex-wrap">
                        <div v-if="comment.images" class="comment-image-wrapper preview-container">
                          <div v-for="image in comment.images" :key="image.image_id" class="img-preview" @click="previewImage(image.url)">
                            <img :src="image.url" />
                          </div>
                        </div>
                        <div class="avatar-icon-wrapper">
                          <div class="avatar-icon-wrapper ml-1">
                            <div class="avatar-icon avatar-icon-lg rounded">
                              <img v-if="comment.thumbnail" :src="comment.thumbnail" />
                              <img v-else :src="noThumbnail" />
                            </div>
                          </div>
                        </div>
                        <div class="chat-comment">
                          <div class="chat-box" v-html="comment.text"></div>
                          <small class="opacity-6 d-inline">
                            <i class="fa fa-calendar-alt mr-1"></i>
                            <span v-html="comment.date_created"></span> | <span>{{ comment.client_name }}</span> |
                          </small>
                          <small class="d-inline">
                            <a href="#input-comment" @click="replyComment(comment)">Reply</a>
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="input-comment" class="d-flex flex-wrap align-items-center input-comment" ref="commentInput">
                  <div class="position-relative">
                    <textarea type="text" name="msg" class="form-control scrollbar" :value="query.comment.text" placeholder="Send comment" @change="query.comment.text = $event.currentTarget.value"></textarea>
                    <svg class="submit" height="20px" width="20px" viewBox="0 0 24 24" @click.stop.prevent="sendComment()">
                      <path d="M16.6915026,12.4744748 L3.50612381,13.2599618 C3.19218622,13.2599618 3.03521743,13.4170592 3.03521743,13.5741566 L1.15159189,20.0151496 C0.8376543,20.8006365 0.99,21.89 1.77946707,22.52 C2.41,22.99 3.50612381,23.1 4.13399899,22.8429026 L21.714504,14.0454487 C22.6563168,13.5741566 23.1272231,12.6315722 22.9702544,11.6889879 C22.8132856,11.0605983 22.3423792,10.4322088 21.714504,10.118014 L4.13399899,1.16346272 C3.34915502,0.9 2.40734225,1.00636533 1.77946707,1.4776575 C0.994623095,2.10604706 0.8376543,3.0486314 1.15159189,3.99121575 L3.03521743,10.4322088 C3.03521743,10.5893061 3.34915502,10.7464035 3.50612381,10.7464035 L16.6915026,11.5318905 C16.6915026,11.5318905 17.1624089,11.5318905 17.1624089,12.0031827 C17.1624089,12.4744748 16.6915026,12.4744748 16.6915026,12.4744748 Z" fill-rule="evenodd" stroke="none"></path>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Body>
</template>

<script>
import Header from '@/layouts/Header.vue'
import SideBar from '@/layouts/SideBar.vue'
import Body from '@/layouts/Body.vue'
import Event from '@/helper/event.js'

export default {
  components: {
    Header,
    Body,
    SideBar
  },
  mixins: [Event],
  data() {
    return {
      preload: true,
      noThumbnail: '@/../assets/imgs/shop-icon.png',
      query: {
        accounts: {
          selected: false,
          page: 1,
          search: '',
          total: false
        },
        client: {
          selected: false,
          offset: ''
        },
        comment: {
          text: ''
        }
      },
      accounts: {},
      clients: {},
      comments: {}
    }
  },
  computed: {
    storeId() {
      return 'main'
    },
    indexUri() {
      return 'sale-account-comment'
    }
  },
  mounted() {
    let interval = setInterval(() => {
      if (this.onResize()) {
        clearInterval(interval)
      }
    }, 100)
    this.$refs.accountSidebar.addEventListener('scroll', () => {
      if (this.query.accounts.total > 0 || this.query.accounts.total === false) {
        let element = this.$refs.accountSidebar
        if (element.scrollHeight - element.scrollTop <= element.clientHeight + 50) {
          this.query.accounts.page++
          this.reloadAccountData()
        }
      }
    })
    window.addEventListener('resize', this.onResize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize() {
      let autoHeight = ['accountSidebar', 'clientSidebar']
      autoHeight.forEach((elem) => {
        if (this.$refs[elem]) {
          this.$refs[elem].style.height = window.innerHeight - this.$util.getOffset(this.$refs[elem]).top + 'px'
        }
      })
      if (this.$refs.messegerContent) {
        this.$refs.messegerContent.style.height = window.innerHeight - this.$util.getOffset(this.$refs.messegerContent).top - 80 + 'px'
      }
      if (window.innerHeight == document.body.offsetHeight) {
        return true
      }
      return false
    },
    setUpData(rawData) {
      if (!_.isArray(rawData.items)) return
      let accounts = Object.values(this.accounts)
      if (this.query.accounts.page < 2) {
        accounts = []
      }

      rawData.items.forEach((items) => {
        items.children.forEach((item) => {
          item.platform = items.text
          accounts.push(item)
        })
      })

      this.query.accounts = Object.assign(this.query.accounts, {
        total: rawData.total
      })
      this.accounts = accounts
    },
    searchAccount() {
      this.query.accounts.page = 1
      this.reloadAccountData()
    },
    chooseAccount(accoundId) {
      this.query.accounts.selected = accoundId
      this.initClient()
    },
    reloadAccountData() {
      this.fetchData(this.query.accounts, {
        $el: this.$refs.accountSidebar
      })
    },
    initClient() {
      if (String(this.query.accounts.selected).length > 0) {
        this.$util.get(`sale-account-comment/get-client/${this.query.accounts.selected}`, this.query.client, this.$refs.clientSidebar, {
          done: (response) => {
            if (!_.isArray(response.items)) return
            this.query.client = Object.assign(this.query.client, {
              offset: response.offset
            })
            this.clients = response.items
          }
        })
      } else {
        this.$util.notify({
          status: 'warning',
          text: 'Please choose account!'
        })
      }
    },

    chooseClient(clientId) {
      this.query.client.selected = clientId
      this.initComment()
    },
    initComment() {
      let data = {
        client_id: this.query.client.selected
      }

      if (String(data.account_id).length > 0 && String(data.client_id).length > 0) {
        this.$util.get(`sale-account-comment/get-client-comment/${this.query.accounts.selected}`, data, this.$refs.commentWrapper, {
          done: (response) => {
            if (!_.isArray(response.items)) return
            this.comments = response.items
          }
        })
      } else {
        this.$util.notify({
          status: 'warning',
          text: 'Please choose account and customer!'
        })
      }
    },
    replyComment(comment) {
      this.query.comment.text = this.query.comment.text.replace(new RegExp('^\\@\\w+\\s+', 'g'), '')
      this.query.comment.text = `@${comment.client_name} ` + this.query.comment.text
    },
    sendComment() {
      let data = {
        client_id: this.query.client.selected,
        comment: this.query.comment
      }
      this.$util.post(`sale-account-comment/send-client-comment/${this.query.accounts.selected}`, data, this.$refs.commentInput, {
        done: (response) => {
          if (response?.comment?.id) return
          this.comments.push(response.comment)
          this.query.comment.text = ''
          let element = this.$refs.commentWrapper
          let scrollInterval = setInterval(() => {
            if (element.scrollHeight > 0) {
              element.scrollTo(0, element.scrollHeight - element.clientHeight)
            }
            clearInterval(scrollInterval)
          }, 50)
        }
      })
    }
  }
}
</script>
<style lang="scss">
body.page-schedule-line-item {
  .scroll-to-top {
    display: none;
  }
}

.page-sale-account-comment-container {
  margin: -30px;
  border-top: 1px solid #e9ecef;
  .app-inner-layout__top-pane {
    .pane-right.attachment {
      > a {
        color: #fff;
        cursor: pointer;
        user-select: none;
      }
    }
  }
  .app-inner-layout__wrapper {
    min-height: 0;
    .app-inner-layout__sidebar.card {
      width: 300px;
      flex: 0 0 300px;
      border-left: 0;
      .displaying-num {
        display: none;
      }
      .tablenav-pages {
        display: flex;
        justify-content: center;
        float: none;
      }
      .dropdown-item {
        min-height: 80px;
        border-bottom: 1px solid #efefef;
      }
      .client-excerpt {
        max-width: 170px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .comment-count {
        position: absolute;
        top: -4px;
        right: -4px;
        width: 22px;
        height: 22px;
        background: #c50000;
        border-radius: 50%;
        border: 1px solid #fff;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
      }
      .app-inner-layout__sidebar-body {
        overflow: auto;
        overflow-x: hidden;
        .dropdown-item {
          position: relative;
          &.active {
            .icon-wrapper {
              i {
                color: #fff !important;
              }
            }
          }
        }
        .item {
          &.item-readed,
          &.item-unread {
            > .dropdown-item {
              padding: 0 !important;
              min-height: 0 !important;
              > .widget-content {
                min-height: 80px;
                padding: 0.4rem 1.5rem !important;
                display: flex;
              }
            }
            .dropdown {
              position: absolute;
              right: 0;
              z-index: 999999999;
              top: 50%;
              transform: translateY(-50%);
              cursor: pointer;
              > div.icon-wrapper {
                width: 28px;
                height: 28px;
                padding: 5px;
              }
              .dropdown-menu {
                left: -15px !important;
              }
              i {
                color: #333;
                font-size: 16px;
              }
              a {
                display: block;
                padding: 10px 20px;
                color: #333;
                &:hover {
                  color: #fff;
                  background-color: #3f6ad8;
                }
              }
            }
          }
        }

        .item.item-readed {
          .widget-content {
            opacity: 0.7;
          }

          /* .fa-fw {
            content: ;
            &:hover {
              content: ;
            }
          } */
        }
        .item.item-unread {
          .dropdown-item {
            background: #c5e3ff;
            border-bottom: 1px solid #2196f3;
          }
          .widget-content {
            opacity: 1;
          }
          .widget-heading {
            opacity: 1;
            font-weight: 500;
          }
          .widget-subheading {
            opacity: 1;
          }
          .dropdown {
            i {
              color: #333;
            }
          }
        }
      }
    }
    .app-inner-layout__content.card {
      &.has-overlay {
        &::before {
          content: '';
          display: block;
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          z-index: 999;
          background: #fff;
          opacity: 0.5;
        }
      }
      .chat-wrapper {
        overflow: auto;
        > div > div {
          clear: both;
          max-width: 90%;
        }
        .chat-box {
          display: block;
        }
        .chat-comment {
          flex: 1;
        }
        .comment-image-wrapper {
          display: flex;
          order: 0;
          width: 100%;
          margin-bottom: 5px;
          .img-preview {
            width: 80px;
            height: 80px;
            margin-left: 5px;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              border: 1px solid #dfdfdf;
              border-radius: var(--border-radius, 0.25rem);
            }
          }
        }
        .float-right .comment-image-wrapper {
          justify-content: flex-end;
        }
        .chat-box-wrapper.chat-box-wrapper-right {
          justify-content: flex-end;
          .avatar-icon-wrapper {
            order: 2;
          }
          .chat-comment {
            order: 1;
          }
        }
      }
      .input-comment {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        z-index: 10;
        background: #fff;
        margin: 10px 0px;
        > div {
          width: 100%;
          padding: 0 20px;
        }
        textarea {
          padding-right: 80px;
          background: #f5f5f5;
          border: 0;
          border-radius: var(--border-radius, 0.25rem);
          flex: 1;
          font-size: 14px;
        }
        .submit {
          position: absolute;
          cursor: pointer;
          top: calc(50% - 10px);
          right: 35px;
          fill: #ccc;
          z-index: 9;
          top: 0;
          height: 40px;
          &:hover {
            fill: #3f6ad8;
          }
        }
        .image-comment {
          background: #f5f5f5;
          padding: 5px 15px;
          margin-bottom: 5px;
          display: inline-block;
          border-radius: 100px;
          max-width: 100%;
          cursor: pointer;
          user-select: none;
          span {
            white-space: nowrap;
            overflow: hidden;
            display: block;
          }
        }
        .add-images {
          position: absolute;
          width: 40px;
          height: 36px;
          right: 56px;
          cursor: pointer;
          top: 0;
          margin: 0 0;
          display: flex;
          align-items: center;
          justify-content: center;
          .background-svg {
            fill: #ccc;
          }
          .border-svg {
            stroke: #ccc;
          }
          &:hover {
            .background-svg {
              fill: #3f6ad8;
            }
            .border-svg {
              stroke: #3f6ad8;
            }
          }
        }
      }
    }
  }
}
</style>
